import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ipApi = defineConnector({
  identifier: "ipApi",
  name: "IP-API",
  tagLine: "IP geolocation lookup service",
  logo,
  protocol: "http",
  tags: ["data"],
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your IP-API Pro key",
      items: [
        {
          kind: "markdown",
          content:
            "IP-API’s HTTPS endpoint requires a Pro key. Copy your key from the IP-API dashboard and send it as the `key` query parameter.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://pro.ip-api.com/json/8.8.8.8?fields=status,countryCode",
  },
  defaultUrlPattern: () => "https://pro\\.ip-api\\.com/.*",
});
